import React, { useState, useRef, useEffect } from 'react';
import { Select, message } from 'antd';
import { getSchools } from '../../api/schools';
import { apiErrorMessage } from '../../utils/apiError';

const { Option } = Select;

export const SCHOOL_TYPE_LABELS = {
  anaokulu: 'Anaokulu',
  ilkokul:  'İlkokul',
  ortaokul: 'Ortaokul',
  lise:     'Lise',
  diger:    'Diğer',
};

/**
 * Okul secici — sunucu tarafli arama (UserSearchSelect ile ayni orunt u).
 *
 * Ogrenci formlarindaki SERBEST METIN okul alaninin yerini aliyor. Serbest
 * metin yuzunden 392 ogrenci icin 191 farkli yazim olusmustu; secim kutusu
 * bunun tekrar etmesini engelliyor.
 *
 * Listede olmayan bir okulla karsilasilirsa kullanici BURADAN EKLEYEMEZ -
 * Okullar sayfasindan (schools.manage izniyle, sube muduru ve ustu) eklenir.
 * Bilinçli bir kisit: ekleme herkese acik olsaydi ayni karmasa geri gelirdi.
 *
 * initialOption: duzenleme ekraninda secili okulun adini aramadan once de
 * gosterebilmek icin (aksi halde kutu ham ID gosterirdi).
 */
const SchoolSelect = ({
  value,
  onChange,
  placeholder = 'Okul aramak için en az 2 karakter yazın...',
  minChars = 2,
  initialOption,
  ...rest
}) => {
  const [options, setOptions] = useState(initialOption ? [initialOption] : []);
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState(null);
  const searchTimer = useRef(null);

  useEffect(() => {
    if (!initialOption) return;
    setOptions((prev) => (
      prev.some((o) => o.id === initialOption.id) ? prev : [initialOption, ...prev]
    ));
  }, [initialOption]);

  const handleSearch = (text) => {
    clearTimeout(searchTimer.current);
    if (!text || text.trim().length < minChars) return;

    searchTimer.current = setTimeout(async () => {
      setLoading(true);
      setErrorText(null);
      try {
        const res = await getSchools({
          search: text.trim(),
          // Pasif okullar secilemez: kapanmis bir okula yeni ogrenci
          // baglanmamali. Mevcut kayitlar etkilenmiyor - onlar initialOption
          // ile zaten gosteriliyor.
          is_active: 1,
          per_page: 20,
        });
        const found = res.data?.data || [];
        // Secili kaydi listede tut, aksi halde baska bir arama yapilinca
        // secim etiketi kaybolup ham ID olarak gorunur.
        setOptions((prev) => {
          const keep = prev.filter((p) => p.id === value && !found.some((f) => f.id === p.id));
          return [...keep, ...found];
        });
      } catch (error) {
        setOptions([]);
        const text = apiErrorMessage(error, 'Okul araması başarısız oldu.');
        setErrorText(text);
        message.error(text);
      } finally {
        setLoading(false);
      }
    }, 300);
  };

  return (
    <Select
      showSearch
      allowClear
      value={value}
      onChange={onChange}
      onSearch={handleSearch}
      filterOption={false}
      loading={loading}
      placeholder={placeholder}
      notFoundContent={
        loading
          ? 'Aranıyor...'
          : errorText
            ? <span style={{ color: '#ff4d4f' }}>{errorText}</span>
            : 'Aramak için en az 2 karakter yazın'
      }
      {...rest}
    >
      {options.map((s) => (
        <Option key={s.id} value={s.id}>
          {s.name}
          {s.type ? ` — ${SCHOOL_TYPE_LABELS[s.type] || s.type}` : ''}
        </Option>
      ))}
    </Select>
  );
};

export default SchoolSelect;
